import React from 'react'
import style from './EditQuestionCard.module.css'
import { useState } from 'react'
import { Modal } from '../index'
import { useEffect } from 'react'

const EditQuestionCard = ({ question }) => {

    const [editMode, setEditMode] = useState(false)
    const [isDisabled, setIsDisabled] = useState(true)

    const [questionTitle, setQuestionTitle] = useState(question?.questionText)
    const [answer1, setAnswer1] = useState(question?.answerOptions[0].answerText)
    const [answer2, setAnswer2] = useState(question?.answerOptions[1].answerText)
    const [answer3, setAnswer3] = useState(question?.answerOptions[2].answerText)

    const [confirmModal, setConfrimModal] = useState(false)
    const [okModal, setOkModal] = useState(false)

    useEffect(() => {
        if(answer1.length > 0 && answer2.length > 0 && answer3.length > 0 && questionTitle.length > 0) {
            setIsDisabled(false)
        } else {
            setIsDisabled(true)
        }
    }, [questionTitle, answer1, answer2, answer3])

    const saveOption = () => {

        let updatedQuestion = {
            ...question
        }
        const newAnswers = [{answerText: answer1, isCorrect: false},{answerText: answer2, isCorrect: false},{answerText: answer3, isCorrect: true}]
        
        updatedQuestion.questionText = questionTitle;
        updatedQuestion.answerOptions = newAnswers;

        const url = 'https://quiz-laura-default-rtdb.firebaseio.com/questions/' + question.id + '.json';
        const body = { ...updatedQuestion };

        const options = {
            method: 'PUT',
            headers: new Headers({'Content-type': 'application/json'}),
            body: JSON.stringify(body),
        };

        fetch(url, options)
            .then(response => {console.log('response', response)})
            .then(payload => {console.log('a', payload)})
            .catch(error => console.log(error));

        setConfrimModal(false);
        setOkModal(true)
    }

    const showConfirmModal = () => {
        setConfrimModal(true);
    }

    const cancelFirstModal = () => {
        setConfrimModal(false);
    }

    const cancelSave = () => {
        setQuestionTitle(question?.questionText)
        setAnswer1(question?.answerOptions[0].answerText)
        setAnswer2(question?.answerOptions[1].answerText)
        setAnswer3(question?.answerOptions[2].answerText)

        setEditMode(false)
    }

    const finishSave = () => {
        window.location.reload(false);
    }

    const closeModals = () => {
        setEditMode(false)
        setConfrimModal(false);
        setOkModal(false);
    }

    return (
        <div className={style.container}>
            {
                editMode 
                    ?
                    <>
                    <span className={style.alert} data-disabled={questionTitle.length < 1}>Campo obligatorio</span>
                    <input className={style.questionTitle} type="text" value={questionTitle} onInput={e => setQuestionTitle(e.target.value)}/>
                    <div className={style.answer_container}>

                        <p className={style.answer_signature}>Respuesta uno:</p>
                        <span className={style.alert} data-disabled={answer1.length < 1}>Campo obligatorio</span>
                        <textarea className={style.input} value={answer1} onInput={e => setAnswer1(e.target.value)}></textarea>

                        <p className={style.answer_signature}>Respuesta dos:</p>
                        <span className={style.alert} data-disabled={answer2.length < 1}>Campo obligatorio</span>
                        <textarea className={style.input} value={answer2} onInput={e => setAnswer2(e.target.value)}></textarea>

                        <p className={style.answer_signature}>Respuesta correcta:</p>
                        <span className={style.alert} data-disabled={answer3.length < 1}>Campo obligatorio</span>
                        <textarea className={style.input_correct} value={answer3} onInput={e => setAnswer3(e.target.value)}></textarea>
                    </div>
                    </>
                    :
                    <>
                    <h1 className={style.title}>{question.questionText}</h1>
                    <div className={style.answer_container}>
                        <p className={style.answer_signature}>Respuesta uno:</p>
                        <p className={style.answer}>- {question.answerOptions[0].answerText}</p>
                        <p className={style.answer_signature}>Respuesta dos:</p>
                        <p className={style.answer}> - {question.answerOptions[1].answerText}</p>
                        <p className={style.answer_signature}>Respuesta correcta:</p>
                        <p className={style.answer_correct}>- {question.answerOptions[2].answerText}</p>
                    </div>
                    </>
            }

            <div className={style.icons_container}>

                {
                    editMode 
                        ?
                        <>
                        <button className={style.button} onClick={showConfirmModal} disabled={isDisabled} data-disabled={isDisabled}>Guardar</button>
                        <button className={style.cancel_button} onClick={cancelSave}>Cancelar</button>
                        </>
                        :
                        <button className={style.button} onClick={() => {setEditMode(true)}}>Editar</button>
                }
            </div>
            <Modal 
                type="confirmChange" title="Estas por cambiar un dato" text="Estas seguro?" 
                showModal={confirmModal} onClick={saveOption} cancelClick={cancelFirstModal}
            />
            <Modal 
                type='changed' title="Guardado" text="Se ha confirmado el cambio." 
                showModal={okModal} onClick={finishSave} cancelClick={closeModals}
            />

        </div>
    )
}

export default EditQuestionCard